export default (file: File | Blob) => {
  return new Promise<string | null>((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result as string | null)
    reader.onerror = error => reject(error)
  })
}
